import React from 'react'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Globe, QrCode, Monitor, Server, ArrowRight } from 'lucide-react'

export const BaresSuitePillars: React.FC = () => {
  const { t } = useTranslation('bares')

  const pillars = [
    { icon: Globe, title: t('pillars.site.title'), desc: t('pillars.site.desc'), color: 'text-amber-600', bg: 'bg-gradient-to-br from-amber-50 to-orange-50', iconBg: 'bg-amber-100' },
    { icon: QrCode, title: t('pillars.menu.title'), desc: t('pillars.menu.desc'), color: 'text-orange-600', bg: 'bg-gradient-to-br from-orange-50 to-amber-50', iconBg: 'bg-orange-100' },
    { icon: Monitor, title: t('pillars.kds.title'), desc: t('pillars.kds.desc'), color: 'text-yellow-700', bg: 'bg-gradient-to-br from-yellow-50 to-amber-50', iconBg: 'bg-yellow-100' },
    { icon: Server, title: t('pillars.erp.title'), desc: t('pillars.erp.desc'), color: 'text-amber-700', bg: 'bg-gradient-to-br from-amber-50 to-yellow-50', iconBg: 'bg-amber-100' }
  ]

  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-0 right-0 w-96 h-96 bg-amber-200/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-orange-200/20 rounded-full blur-3xl"></div>
      </div>

      <div className="container relative z-10">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-flex items-center gap-2 px-4 py-2 bg-amber-100 text-amber-700 rounded-full text-sm font-semibold mb-4"
          >
            <Server className="w-4 h-4" />
            {t('pillars.kicker', 'Solução Completa')}
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-4"
          >
            {t('pillars.title')}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-xl text-gray-600 max-w-3xl mx-auto"
          >
            {t('pillars.subtitle')}
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {pillars.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              className={`group relative p-8 rounded-2xl ${p.bg} border border-gray-200/50 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2`}
            >
              <div className={`w-16 h-16 ${p.iconBg} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-md`}>
                <p.icon className={`w-8 h-8 ${p.color}`} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{p.title}</h3>
              <p className="text-gray-700 text-sm leading-relaxed mb-4">{p.desc}</p>

              <div className="flex items-center text-amber-600 text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span>Saiba mais</span>
                <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
